import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { toast } from 'react-toastify';
import HeaderPage from '~/components/HeaderPage';
import { ApplicationState } from '~/store';
import {
  getAssuntosHandleChangePageRequest,
  getAssuntosRequest,
  postAssuntosRequest,
  updateAssuntosRequest,
} from '~/store/ducks/CriacaoDosAssuntosDeContato/actions';
import { Container, StyledButton } from './styles';
import Table from './Table';

const CriacaoDosAssuntosDeContato: React.FC = () => {
  const dispatch = useDispatch();

  const auth = useSelector<ApplicationState, any>(state => state.auth);

  const [ResetPage, setResetPage] = React.useState<number>(0);

  const [incluirAssunto, setIncluirAssunto] = useState('');

  const handleChangeAssunto = useCallback(
    (event: React.ChangeEvent<HTMLTextAreaElement>) => {
      setIncluirAssunto(event.target.value);
    },
    [],
  );

  const assuntos = useSelector<ApplicationState, any[]>(
    state => state.criacaoAssunto.data,
  );

  const gerAssuntos = useCallback(() => {
    dispatch(getAssuntosRequest(auth?.company?.country_company_id));
  }, [auth, dispatch]);

  useEffect(() => {
    gerAssuntos();
  }, [gerAssuntos]);

  return (
    <Container>
      <HeaderPage pageTitle="Criação dos assuntos de contato" />

      <div className="main-content-assuntos">
        <h1>Criar novo assunto</h1>

        <div className="assuntos">
          <textarea
            id="incluirAssunto"
            value={incluirAssunto}
            onChange={handleChangeAssunto}
            rows={1}
            placeholder="Digite aqui um novo assunto"
            className="message-DPO"
          />
        </div>
        <StyledButton
          className="button-continue"
          onClick={() => {
            if (incluirAssunto.length > 5) {
              const toastrConfirmOptions = {
                onOk: () => {
                  dispatch(
                    postAssuntosRequest({
                      country_company_id: auth?.company?.country_company_id,
                      subject_ds: incluirAssunto,
                    }),
                  );
                  setIncluirAssunto('');
                  setResetPage(ResetPage + 1);
                },
                onCancel: () => {},
                okText: 'Sim',
                cancelText: 'Não',
              };

              toastr.confirm(
                'Tem certeza que deseja incluir este assunto?',
                toastrConfirmOptions,
              );
            } else {
              toast.error(
                'Necessário o minimo de 5 caracteres para incluir o assunto',
              );
            }
          }}
        >
          Incluir
        </StyledButton>
      </div>

      <div className="lista-assuntos">
        <h2>Lista de assuntos</h2>

        <Table
          ResetPage={ResetPage}
          data={assuntos}
          toggleAction
          className="table-lgpd"
          getOrderHandleChangePage={(value: number, rowsPerPage: number) =>
            dispatch(
              getAssuntosHandleChangePageRequest(
                value,
                rowsPerPage,
                auth?.company?.country_company_id,
              ),
            )
          }
        />
      </div>

      <StyledButton
        style={{ marginBottom: 40, marginTop: 40 }}
        onClick={() => {
          const toastrConfirmOptions = {
            onOk: () => {
              dispatch(
                updateAssuntosRequest(auth?.company?.country_company_id, ''),
              );
              setResetPage(ResetPage + 1);
            },
            onCancel: () => {},
            okText: 'Sim',
            cancelText: 'Não',
          };

          toastr.confirm(
            'Tem certeza que deseja fazer essa alteração?',
            toastrConfirmOptions,
          );
        }}
      >
        Salvar alteração
      </StyledButton>
    </Container>
  );
};

export default CriacaoDosAssuntosDeContato;
